import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M7 5a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2l0 -10","key":"svg-0"}],["path",{"d":"M17 17v2a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h2","key":"svg-1"}],["path",{"d":"M15 14v-8l-4 6h5","key":"svg-2"}]]

const IconBoxMultiple4 = createReactComponent('outline', 'box-multiple-4', 'BoxMultiple4', __iconNode);

export default IconBoxMultiple4;